
export const initialuserstate =  {
    roleName:'',
    roleChecked:false,
    checkingRole:false,
    status
}




// WEBPACK FOOTER //
// ./src/redux/initialuserstate.js